var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-panel",
    { staticClass: "parcel-detail" },
    [
      _c(
        "h2",
        [
          _vm._v("Perceel "),
          [
            _vm._v(
              " " +
                _vm._s(_vm.parcel.parcelLocation.name) +
                " " +
                _vm._s(_vm.parcel.parcelLocation.number) +
                " "
            ),
          ],
          _vm.parcel.alias
            ? [_vm._v(" - " + _vm._s(_vm.parcel.alias) + " ")]
            : _vm._e(),
        ],
        2
      ),
      _c("span", { staticClass: "efficiency" }, [
        _vm._v(
          "Rendement: " +
            _vm._s(_vm._f("number")(_vm.parcel.efficiency * 100)) +
            "%"
        ),
      ]),
      _vm.parcelSowingDensity != null
        ? _c("span", { staticClass: "efficiency" }, [
            _vm._v(
              "Zaaidichtheid: " +
                _vm._s(_vm._f("number")(_vm.parcelSowingDensity)) +
                " mTon/ha"
            ),
          ])
        : _vm._e(),
      _vm._l(_vm.sections, function (section) {
        return _c("pm-section-detail", {
          key: section.id,
          attrs: {
            section: section,
            parcel: _vm.parcel,
            editable: _vm.editable,
            deletable: _vm.deletable,
            type: _vm.type,
            "start-date": _vm.startDate,
            "end-date": _vm.endDate,
            open: _vm.openSectionTables.indexOf(section.id) >= 0,
          },
          on: {
            toggle: function ($event) {
              return _vm.toggleSectionTable(section.id)
            },
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }